export enum SortOrderEnum {

  ASC = 'asc',
  DESC = 'desc'

}


export class SortListModel {

  field: string;

  name: string;

  sortOrder: SortOrderEnum;

  nestedField: string;

  isDateType?: boolean;

  isCharType?: boolean;

  constructor(attr: { field: string, name: string, sortOrder: SortOrderEnum, nestedField?: string , isDateType?: boolean, isCharType?: boolean }) {
    this.field = attr.field;
    this.name = attr.name;
    this.sortOrder = attr.sortOrder;
    this.nestedField = attr.nestedField;
    this.isDateType = attr.isDateType;
    this.isCharType = attr.isCharType;
  }
}
